import React, { useState } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import SearchBar from '../Search';
import Header from '../common/Header';
import Footer from '../common/Footer';
import usePageTracking from '../lib/usePageTracking';
import { format } from 'date-fns';

const Home = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [currency, setCurrency] = useState('SDG');
  const { referral_code: referralCode } = useParams();
  const { message } = location.state || {};

  usePageTracking();

  return (
    <>
      <div className="splash">
        <Header selectCurrency={setCurrency} />
        {message && <div className='welcome-message'>
          <p>{message}</p>
        </div>}
        <div className="slogan-box">
          <h1>
            كُنْ أَنْت وِكالة السَّفر
          </h1>
        </div>

        <SearchBar handleSearch={params => {
          const { tripType, departureStation, departureDate, destinationStation, returnDate } = params;
          navigate(`/offers?tripType=${tripType}&departureStation=${departureStation.iataCode}&destinationStation=${destinationStation.iataCode}&departureDate=${format(departureDate, 'yyyy-MM-dd')}${tripType == 'round-trip' ? `&returnDate=${format(returnDate, 'yyyy-MM-dd')}` : ''}`, { state: { ...params, currency } });
        }
        } />

      </div>
      <Footer />
    </>
  );
};

export default Home;